import { taskCategoriesSlice } from "./taskCategoriesSlice";
import * as actions from "./taskCategoriesActions";
import * as selectors from "./taskCategoriesSelectors";

export { actions };
export { selectors };
export default taskCategoriesSlice.reducer;
